import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { ISectionState } from "@/store/modules/section/types";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const sectionModule: Module<ISectionState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
